import React from 'react';
import './MobileNavigation.css';
import { OverviewIcon, PositionsIcon, HedgingIcon, FundingIcon, SettingsIcon } from './icons/NavigationIcons';

function MobileNavigation({ activeView, onViewChange }) {
  const tabs = [
    { id: 'overview', label: 'Overview', Icon: OverviewIcon },
    { id: 'positions', label: 'Positions', Icon: PositionsIcon },
    { id: 'hedging', label: 'Hedging', Icon: HedgingIcon },
    { id: 'funding', label: 'Funding', Icon: FundingIcon },
    { id: 'settings', label: 'Settings', Icon: SettingsIcon },
  ];

  const handleTabClick = (tabId) => {
    if (onViewChange) {
      onViewChange(tabId);
    }
  };

  return (
    <nav className="mobile-navigation">
      {tabs.map(tab => {
        const Icon = tab.Icon;
        const isActive = activeView === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            className={`nav-tab ${isActive ? 'active' : ''}`}
            onClick={() => handleTabClick(tab.id)}
            onTouchEnd={(e) => {
              e.preventDefault();
              handleTabClick(tab.id);
            }}
            aria-label={tab.label}
          >
            <span className="nav-icon">
              <Icon active={isActive} />
            </span>
            <span className="nav-label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default MobileNavigation;

